import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic223 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    responsibleBusinessConductCommitments: {
      businessConductPolicy: "",
      OECD: "",
      dueDiligenceProcedure: "",
      precautionaryPrincipleCommitment: "",
      humanRightsCommitment: "",
    },

    specificHumanRightsPolicy: {
      policyCommitment: "",
      humanRightsFrameworkReferences: "",
      stakeholderIdentificationHumanRights: "",
    },

    policyCommitmentLinks: "",
    approvalLevelHumanRightsCommitment: "",
    policyCommitmentScope: "",
    policyCommitmentCommunication: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `/gri/get?type=GeneralDisclosures2021&Id=${id}`
        );
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data =
          response.data.data.GeneralDisclosures2021?.policyCommitments || {};
        setFormData({
          responsibleBusinessConductCommitments: {
            businessConductPolicy:
              data.responsibleBusinessConductCommitments
                ?.businessConductPolicy || "",
            OECD: data.responsibleBusinessConductCommitments?.OECD || "",
            dueDiligenceProcedure:
              data.responsibleBusinessConductCommitments
                ?.dueDiligenceProcedure || "",
            precautionaryPrincipleCommitment:
              data.responsibleBusinessConductCommitments
                ?.precautionaryPrincipleCommitment || "",
            humanRightsCommitment:
              data.responsibleBusinessConductCommitments
                ?.humanRightsCommitment || "",
          },

          specificHumanRightsPolicy: {
            policyCommitment:
              data.specificHumanRightsPolicy?.policyCommitment || "",
            humanRightsFrameworkReferences:
              data.specificHumanRightsPolicy?.humanRightsFrameworkReferences ||
              "",
            stakeholderIdentificationHumanRights:
              data.specificHumanRightsPolicy
                ?.stakeholderIdentificationHumanRights || "",
          },
          policyCommitmentLinks: data.policyCommitmentLinks || "",
          approvalLevelHumanRightsCommitment:
            data.approvalLevelHumanRightsCommitment || "",
          policyCommitmentScope: data.policyCommitmentScope || "",
          policyCommitmentCommunication:
            data.policyCommitmentCommunication || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    // Validate required fields in the formData
    if (!formData.responsibleBusinessConductCommitments.businessConductPolicy) {
      newErrors.businessConductPolicy = "This field is required";
      formIsValid = false;
    }

    if (!formData.responsibleBusinessConductCommitments.OECD) {
      newErrors.OECD = "This field is required";
      formIsValid = false;
    }

    if (!formData.responsibleBusinessConductCommitments.dueDiligenceProcedure) {
      newErrors.dueDiligenceProcedure = "This field is required";
      formIsValid = false;
    }

    if (
      !formData.responsibleBusinessConductCommitments
        .precautionaryPrincipleCommitment
    ) {
      newErrors.precautionaryPrincipleCommitment = "This field is required";
      formIsValid = false;
    }

    if (!formData.responsibleBusinessConductCommitments.humanRightsCommitment) {
      newErrors.humanRightsCommitment = "This field is required";
      formIsValid = false;
    }

    //sectionB
    if (!formData.specificHumanRightsPolicy.policyCommitment) {
      newErrors.policyCommitment = "This field is required";
      formIsValid = false;
    }

    if (
      !formData.specificHumanRightsPolicy.stakeholderIdentificationHumanRights
    ) {
      newErrors.stakeholderIdentificationHumanRights = "This field is required";
      formIsValid = false;
    }

    if (!formData.specificHumanRightsPolicy.humanRightsFrameworkReferences) {
      newErrors.humanRightsFrameworkReferences = "This field is required";
      formIsValid = false;
    }

    if (!formData.policyCommitmentLinks) {
      newErrors.policyCommitmentLinks = "This field is required";
      formIsValid = false;
    }

    if (!formData.approvalLevelHumanRightsCommitment) {
      newErrors.approvalLevelHumanRightsCommitment = "This field is required";
      formIsValid = false;
    }

    if (!formData.policyCommitmentScope) {
      newErrors.policyCommitmentScope = "This field is required";
      formIsValid = false;
    }

    if (!formData.policyCommitmentCommunication) {
      newErrors.policyCommitmentCommunication = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      const payload = {
        type: "GeneralDisclosures2021",
        policyCommitments: {
          ...formData,
        },
        submitted2_23: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/general-disclosure/2-24/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-24/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      <p className={styles.main_heading}>2-23 Policy commitments</p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}
        <SectionHeading
          text="a. Describe the key principles or commitments outlined in organization's responsible business conduct policy (Sustainability policy outlines values, principles & development process with internal/external expertise)."
          sx={{ marginTop: hide ? "-1rem" : "0rem" }}
        />
        <CustomTextField
          value={
            formData.responsibleBusinessConductCommitments.businessConductPolicy
          }
          onChange={(e) =>
            handleNestedInputChange(
              "responsibleBusinessConductCommitments",
              "businessConductPolicy",
              e.target.value
            )
          }
          error={errors.businessConductPolicy}
          helperText={errors.businessConductPolicy}
          disabled={disabled}
        />

        <Box sx={{ marginLeft: "1.1rem" }}>
          <SectionHeading text="i. Describe the authoritative intergovernmental instruments your organization's responsible business conduct policy references (These might include international conventions, declarations, or principles established by organizations like the United Nations (UN) or the Organization for Economic Co-operation and Development (OECD))." />
          <CustomTextField
            value={formData.responsibleBusinessConductCommitments.OECD}
            onChange={(e) =>
              handleNestedInputChange(
                "responsibleBusinessConductCommitments",
                "OECD",
                e.target.value
              )
            }
            error={errors.OECD}
            helperText={errors.OECD}
            disabled={disabled}
          />

          <SectionHeading text="ii. Describe whether organization's policy require the organization to conduct due diligence to identify, assess, and manage potential social, environmental, and human rights impacts throughout its operations and supply chain. If yes, please provide explaination and procedure. " />
          <CustomTextField
            value={
              formData.responsibleBusinessConductCommitments
                .dueDiligenceProcedure
            }
            // onChange={(e) => handleNestedInputChange("dueDiligenceProcedure", e.target.value)}
            onChange={(e) =>
              handleNestedInputChange(
                "responsibleBusinessConductCommitments",
                "dueDiligenceProcedure",
                e.target.value
              )
            }
            error={errors.dueDiligenceProcedure}
            helperText={errors.dueDiligenceProcedure}
            disabled={disabled}
          />

          <SectionHeading text="iii. Describe whether organization's policy commit the organization to applying the precautionary principle, meaning taking proactive measures to avoid potential environmental harm even when scientific knowledge is incomplete. If yes, please provide explaination and procedure. " />
          <CustomTextField
            value={
              formData.responsibleBusinessConductCommitments
                .precautionaryPrincipleCommitment
            }
            onChange={(e) =>
              handleNestedInputChange(
                "responsibleBusinessConductCommitments",
                "precautionaryPrincipleCommitment",
                e.target.value
              )
            }
            error={errors.precautionaryPrincipleCommitment}
            helperText={errors.precautionaryPrincipleCommitment}
            disabled={disabled}
          />

          <SectionHeading text="iv. Describe whether policy explicitly state the organization's commitment to respecting human rights throughout its operations and supply chain, aligned with internationally recognized human rights principles. If yes, please explain. " />
          <CustomTextField
            value={
              formData.responsibleBusinessConductCommitments
                .humanRightsCommitment
            }
            onChange={(e) =>
              handleNestedInputChange(
                "responsibleBusinessConductCommitments",
                "humanRightsCommitment",
                e.target.value
              )
            }
            error={errors.humanRightsCommitment}
            helperText={errors.humanRightsCommitment}
            disabled={disabled}
          />
        </Box>

        {/* Section B */}
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <SectionHeading
          text="b. Describe organization's specific policy commitment to respect human rights."
          sx={{ marginTop: "2rem" }}
        />
        <CustomTextField
          value={formData.specificHumanRightsPolicy.policyCommitment}
          onChange={(e) =>
            handleNestedInputChange(
              "specificHumanRightsPolicy",
              "policyCommitment",
              e.target.value
            )
          }
          error={errors.policyCommitment}
          helperText={errors.policyCommitment}
          disabled={disabled}
        />
        <Box sx={{ marginLeft: "1.1rem" }}>
          <SectionHeading text="i. Describe whether organization's policy on respecting human rights explicitly reference internationally recognized human rights frameworks, such as the Universal Declaration of Human Rights or the core labor standards of the International Labour Organization (ILO). Please provide with description." />
          <CustomTextField
            value={
              formData.specificHumanRightsPolicy.humanRightsFrameworkReferences
            }
            onChange={(e) =>
              handleNestedInputChange(
                "specificHumanRightsPolicy",
                "humanRightsFrameworkReferences",
                e.target.value
              )
            }
            error={errors.humanRightsFrameworkReferences}
            helperText={errors.humanRightsFrameworkReferences}
            disabled={disabled}
          />

          <SectionHeading text="ii. Describe whether organization's human rights policy identify specific categories of stakeholders, including at-risk or vulnerable groups, that the organization pays particular attention to in its efforts to respect human rights. Please provide with description. " />
          <CustomTextField
            value={
              formData.specificHumanRightsPolicy
                .stakeholderIdentificationHumanRights
            }
            onChange={(e) =>
              handleNestedInputChange(
                "specificHumanRightsPolicy",
                "stakeholderIdentificationHumanRights",
                e.target.value
              )
            }
            error={errors.stakeholderIdentificationHumanRights}
            helperText={errors.stakeholderIdentificationHumanRights}
            disabled={disabled}
          />
        </Box>

        {/* Section C */}
        <SectionHeading text="c. Provide links to the policy commitments if publicly available, or, if the policy commitments are not publicly available, explain the reason for this." />
        <CustomTextField
          value={formData.policyCommitmentLinks}
          onChange={(e) =>
            handleInputChange("policyCommitmentLinks", e.target.value)
          }
          error={errors.policyCommitmentLinks}
          helperText={errors.policyCommitmentLinks}
          disabled={disabled}
        />

        <SectionHeading text="d. Report at what level within the organization were these human rights policy commitments approved? Was this approval at the most senior level, such as the board of directors." />
        <CustomTextField
          value={formData.approvalLevelHumanRightsCommitment}
          onChange={(e) =>
            handleInputChange(
              "approvalLevelHumanRightsCommitment",
              e.target.value
            )
          }
          error={errors.approvalLevelHumanRightsCommitment}
          helperText={errors.approvalLevelHumanRightsCommitment}
          disabled={disabled}
        />

        <SectionHeading text="e. Report the extent to which the policy commitments apply to the organization's activities and to its business relationships." />
        <CustomTextField
          value={formData.policyCommitmentScope}
          onChange={(e) =>
            handleInputChange("policyCommitmentScope", e.target.value)
          }
          error={errors.policyCommitmentScope}
          helperText={errors.policyCommitmentScope}
          disabled={disabled}
        />

        <SectionHeading text="f. Describe how the policy commitments are communicated to workers, business partners, and other relevant parties." />
        <CustomTextField
          value={formData.policyCommitmentCommunication}
          onChange={(e) =>
            handleInputChange("policyCommitmentCommunication", e.target.value)
          }
          error={errors.policyCommitmentCommunication}
          helperText={errors.policyCommitmentCommunication}
          disabled={disabled}
        />

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic223;
